<template>
  <div class="container-fluid" style="padding:0;">
    <tab></tab>
    <div class="row">
      <div class="activity-top" :class="{'hidden-xs hidden-sm':isShowWeb}">
        <img src="@/images/mechanism.png" alt="#" class="inner-item-img"/>
        <div class="activity-top-font">
          <div class="top-font-font">{{lanType==1?pageInfo.title:pageInfo.titleEn}}</div>
        </div>
      </div>

      <div class="phone-activity-top hidden-md hidden-lg" v-if="isShowWeb">
        <img src="@/images/mechanism.png" alt="#" class="phone-inner-img"/>
        <div class="activity-top-font">
          <div class="phone-font-font">{{lanType==1?pageInfo.title:pageInfo.titleEn}}</div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="mechanism-neck" :class="{'hidden-xs hidden-sm':isShowWeb}">
        <div class="mechanism-neck-title">{{lanType==1?pageInfo.title:pageInfo.titleEn}}</div>
        <div class="mechanism-neck-center">
          
          <div class="neck-center-center">
            <div class="center-center-font" v-html="lanType==1?pageInfo.content:pageInfo.contentEn"></div>
            <!-- <div class="center-center-font">会上，由WWF中国制作的科学碳目标中文指导手册正式发布。该手册内容涵盖了企业设立科学碳目标的全部指导性文件，包括目标设立及审核文件、指导手册、工具性文件以及交通运输特别指导文件等，为企业设立基于科学的减排目标提供了极大的便利。同时，会上展示了气候与能源企业合作平台(Climate Business Hub，CBH)，企业通过CBH可以广泛地了解在应对气候变化以及可再生能源应用领域可以做出的贡献，从而更好地展现企业的气候领导力。</div>
            <img src="@/images/mechanismBg.png" alt="#" class="center-center-img"/>
            <div class="center-center-tips">WWF成立时的意见书  ©WWF</div>
            <div class="center-center-font">近年来，气候变化引发的极端天气、水资源短缺、供应链危机等都是影响企业运营发展的潜在风险。根据联合国政府间气候变化专门委员会的报告，气温每上升1°C，粮食产量就下降约5%。气候变化引发的极端天气也是引发今年8月亚马孙雨林大火的诱因之一。根据联合国发布的《2019年世界经济形势与展望》，1998年至2017年之间，与气候相关的灾害造成的损失高达22,450亿美元。</div>
            <div class="center-center-font">企业既是温室气体的主要排放者，同时又是气候友好型解决方案的创新者和提供者，可以在应对气候变化、实现中国低碳经济转型方面起到关键作用。</div>
            <div class="center-center-font">围绕“低碳先行 企业双赢”的主题，交流会设立了企业案例分享、主题讨论以及问答三个环节，加深企业对科学碳目标倡议的理解、明确自身的时代使命。</div> -->
          </div>

          <div class="neck-center-top spaceBetween hidden">
            <div class="center-top-list" :class="{'center-top-choice':item.isChoice}" v-for="(item,index) in typeList" :key="index" @click="choiceList(index)">{{lanType==1?item.name:item.nameEn}}</div>
            <!-- <div class="center-top-list" @click="choiceList(2)">RE买家联盟</div>
            <div class="center-top-list" @click="choiceList(3)">气候创行者</div> -->
          </div>

          <div class="neck-center-top middle hidden" style="margin-top:0.3rem;">
            <div class="center-top-list bg2" style="width:1.6rem;" @click="submitBtn">{{lanType==1?'提交':'Submit'}}</div>
          </div>
        </div>

      </div>

      <div class="phone-mechanism hidden-md hidden-lg" v-if="isShowWeb">
        <div class="phone-mechanism-neck">{{lanType==1?pageInfo.title:pageInfo.titleEn}}</div>
        <div class="phone-mechanism-time">{{pageInfo.updateTime}}</div>
        <div class="phone-mechanism-center">
          
          <div class="phone-neck-center">
            <div class="phone-center-font" v-html="lanType==1?pageInfo.content:pageInfo.contentEn"></div>
            <!-- <div class="phone-center-font">会上，由WWF中国制作的科学碳目标中文指导手册正式发布。该手册内容涵盖了企业设立科学碳目标的全部指导性文件，包括目标设立及审核文件、指导手册、工具性文件以及交通运输特别指导文件等，为企业设立基于科学的减排目标提供了极大的便利。同时，会上展示了气候与能源企业合作平台(Climate Business Hub，CBH)，企业通过CBH可以广泛地了解在应对气候变化以及可再生能源应用领域可以做出的贡献，从而更好地展现企业的气候领导力。</div>
            <img src="@/images/mechanismBg.png" alt="#" class="phone-center-img"/> -->
            <!-- <div class="phone-center-tips">WWF成立时的意见书  ©WWF</div>
            <div class="phone-center-font">近年来，气候变化引发的极端天气、水资源短缺、供应链危机等都是影响企业运营发展的潜在风险。根据联合国政府间气候变化专门委员会的报告，气温每上升1°C，粮食产量就下降约5%。气候变化引发的极端天气也是引发今年8月亚马孙雨林大火的诱因之一。根据联合国发布的《2019年世界经济形势与展望》，1998年至2017年之间，与气候相关的灾害造成的损失高达22,450亿美元。</div>
            <div class="phone-center-font">企业既是温室气体的主要排放者，同时又是气候友好型解决方案的创新者和提供者，可以在应对气候变化、实现中国低碳经济转型方面起到关键作用。</div>
            <div class="phone-center-font">围绕“低碳先行 企业双赢”的主题，交流会设立了企业案例分享、主题讨论以及问答三个环节，加深企业对科学碳目标倡议的理解、明确自身的时代使命。</div> -->
          </div>

          <div class="phone-center-top spaceBetween hidden">
            <div class="phone-center-list" :class="{'center-top-choice':item.isChoice}" v-for="(item,index) in typeList" :key="index" @click="choiceList(index)">{{lanType==1?item.name:item.nameEn}}</div>
            <!-- <div class="phone-center-list bg1">RE买家联盟</div>
            <div class="phone-center-list bg2">气候创行者</div> -->
          </div>

          <div class="phone-center-top middle hidden" style="margin-top:0.8rem;">
            <div class="phone-center-list bg2" style="width:3.6rem;" @click="submitBtn">{{lanType==1?'提交':'Submit'}}</div>
          </div>
        </div>
      </div>
    </div>

    <footerBar ref="footerView"></footerBar>
  </div>
</template>

<script>
import tab from '@/components/tab';
import footerBar from '@/components/footerBar';
import axios from 'axios';
import { chunkArr } from '@/utils/util';
import config from '@/utils/config';
export default {
  name: 'wprk',
  components: {
    tab:tab,
    footerBar:footerBar
  },
  data () {
    return {
      carouselList:[],
      pageInfo:{},
      type:1,
      id:'',
      isLogin:false,
      typeList:[
        {
          name:'SBTi科学碳目标',
          nameEn:'Science Based Target initiative (SBTi)',
          type:1,
          isChoice:false
        },{
          name:'绿色电力需求倡议',
          nameEn:"Renewable Energy Buyers' Principles",
          type:2,
          isChoice:false
        },{
          name:'气候创行者',
          nameEn:'Climate Solver',
          type:3,
          isChoice:false
        }
      ],
      token:'',
      isShowWeb:config.urlList.isShowWeb,
      lanType:1
    }
  },
  methods:{
    fatherMethod(type){
      const vm=this
      vm.lanType=type
      setTimeout(()=>{
        vm.$refs.footerView.choiceType(type);
      },400)
    },
    choiceList(index){
      const vm=this
      vm.typeList[index].isChoice=!vm.typeList[index].isChoice
    },
    queryPageInfo(){
      const vm=this;
      let str = "<p>CBH recognizes that businesses and industry have key roles in reducing global greenhouse gas emissions and implementing climate-smart technologies and innovations. They must be part of the global effort to tackle climate change, and take their responsibilities to meet the goals of the Paris Agreement.</p><p>It is also a compelling business case to take immediate action on climate change. Companies demonstrating leadership on climate change have shown improved reputation with customers, suppliers, investors, and policy makers. They are staying ahead of future climate regulations with less exposure of climate risks. Reduced energy use and emissions also indicates reduced costs and better efficiency, which leaves better chance for internal innovation.</p><p>Taking climate action simply makes good business sense.</p><p>Leading companies around the world step forward every day to commit to bold climate and renewable energy targets, not only for their direct operations but also for their supply chains. Across sectors — from retail, to textiles and apparel, technology and many others — global supply chains often lead back to China.</p><p>Join Climate Business Hub China. Your climate journey starts here.</p><p>If you would join CBH, or are interested in setting SBTi, or signing Renewable Energy Buyers' Principles please email:</p><p>Yuanna LUO OPF South China contact person, EnergyTransitionto100%Renewable<br/>ynluo@wwf-opf.org</p><p>Qian LIU OPF Assistance Program Officer, Energy Transition to 100% Renewable(Beijing)<br/>qliu@wwf-opf.org</p><p>If you are interested in Climate Solver please email:<br/>Shasha Cheng   Program Manager  Energy Transition & Climate Solver, WWF China<br/>shshchen@wwfchina.org</p>"

      axios.get(
      `${config.urlList.queryUrl}/api/cbh/page/1`,
      ).then(res => {
        if(res.data.code==1){
          res.data.data.titleEn=res.data.data.titleEn?res.data.data.titleEn:'JoinUs'
          res.data.data.contentEn=res.data.data.contentEn?res.data.data.contentEn:str
          res.data.data.updateTime=res.data.data.updated_at.split('T')[0];
          res.data.data.content = res.data.data.content ? res.data.data.content.replace(/(width|height)="\d*"\s*/g, '') : ''
          res.data.data.contentEn = res.data.data.contentEn ? res.data.data.contentEn.replace(/(width|height)="\d*"\s*/g, '') : ''
          vm.pageInfo=res.data.data;
        }
      })
    },
    queryUserinfo(){
      const vm=this;
      vm.token = localStorage.getItem('Cbhtoken');
      if(vm.token){
        vm.isLogin=true
      }
    },
    submitBtn(){
      const vm=this
      let arr=[];
      vm.typeList.forEach(da=>{
        if(da.isChoice){
          arr.push(da.type)
        }
      })
      if(!vm.isLogin){
        vm.$toast({
          text: '您还未登录，请登录后再试！',
          type: 'wraning',
          duration: 1600
        })
        return
      };
      if(localStorage.getItem('CbhuserInfo').is_examine<1){
        vm.$toast({
          text: '您的账号暂未通过审核，请审核后再试！',
          type: 'wraning',
          duration: 1600
        })
        return
      }
      
      if(arr.length===0){
        vm.$toast({
          text: '请选择您感兴趣的项目！',
          type: 'wraning',
          duration: 1600
        })
        return
      }

      axios.post(
      `${config.urlList.queryUrl}/api/cbh/join`,
        {
          type:arr.join(','),
          token:vm.token
        }
      ).then(res => {
        if(res.data.code==1){
          vm.$toast({
            text: '稍后我们会通过邮件与您联系，请注意查收！',
            type: 'wraning',
            duration: 1600
          })
        }
      }).catch(err=>{
        vm.$toast({
          text: '请求接口报错，请稍后再试！',
          type: 'wraning',
          duration: 1600
        })
      })
    }
  },
  created () {
    const vm = this;
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  },
  mounted(){
    const vm=this
    vm.queryPageInfo();
    vm.queryUserinfo();
  }
}
</script>
<style scoped>
/**  pc banner图  **/
.activity-top{
  width: 100%;
  height: 2.20625rem;
  position: relative;
}
.inner-item-img{
  width: 100%;
  height: 100%;
}
.activity-top-font{
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
}
.top-font-font{
  font-size: 0.375rem;
  color: #fff;
}
/**  web Banner图  **/
.phone-activity-top{
  width: 100%;
  height: 8rem;
  position: relative;
}
.phone-inner-img{
  width: 100%;
  height: 100%;
}
.phone-font-font{
  font-size: 0.8rem;
  color: #fff;
}

/**  pc  **/
.mechanism-neck{
  padding: 0.35rem 0.5rem;
  height: auto;
}
.mechanism-neck-title{
  font-size: 0.225rem;
  color: #000;
  text-align: center;
  line-height: 1.6;
  font-family: 'wwf';
}
.mechanism-neck-time,.center-top-tips{
  font-size: 0.1125rem;
  color: #999999;
  line-height: 1.6;
  text-align: center;
}
.mechanism-neck-center{
  margin-top: 0.225rem;
  height: auto;
}
.center-top-list{
  width: 1.4rem;
  height: 0.36rem;
  font-size: 0.14rem;
  color: #323232;
  border: 1px solid #ddd;
  background: #fff;
  text-align: center;
  line-height: 0.36rem;
  margin-right: 0.16rem;
  cursor: pointer;
}
.center-top-choice{
  background: #32a5cf;
  color: #fff;
  border: none;
}
.neck-center-center{
  margin-top: 0.1625rem;
}
.center-center-font{
  font-size: 0.1125rem;
  line-height: 1.6;
  margin-bottom: 0.2rem;
  text-align: left;
}
.center-center-font ul li{list-style: initial;margin-left:0.22rem}
.center-center-img{
  width: 5.625rem;
  height: auto;
  margin-bottom: 0.15rem;
}
.center-center-tips{
  font-size: 0.1rem;
  color: #999;
  text-align: center;
  margin-bottom: 0.225rem;
}

/**  web  **/

.phone-mechanism{
  padding: 0.35rem 0.5rem;
  height: auto;
}
.phone-mechanism-neck{
  font-size: 0.48rem;
  color: #000;
  text-align: center;
  line-height: 1.6;
  font-family: 'wwf';
}
.phone-mechanism-time,.phone-top-tips{
  font-size: 0.32rem;
  color: #999999;
  line-height: 1.6;
  text-align: center;
}
.phone-mechanism-center{
  margin-top: 0.4rem;
  height: auto;
}
.phone-center-list{
  width: 2.4rem;
  height: 0.8rem;
  font-size: 0.32rem;
  color: #fff;
  background: #32a5cf;
  text-align: center;
  line-height: 0.8rem;
  margin-right: 0.3rem;
}
.phone-neck-center{
  margin-top: 0.4rem;
}
.phone-center-font{
  font-size: 0.32rem;
  line-height: 1.6;
  margin-bottom: 0.4rem;
  text-align: left;
}
.phone-center-img{
  width: 100%;
  height: auto;
  margin-bottom: 0.3rem;
}
.phone-center-tips{
  font-size: 0.32rem;
  color: #999;
  text-align: center;
  margin-bottom: 0.4rem;
}
.bg1{
  background: #436aba;
}
.bg2{
  background: #ed9534;
  color: #fff;
  border-radius: 4px;
}
</style>

